import { put, takeLatest, call, all } from 'redux-saga/effects';
import types from '../../types';
import api from '../../../services/api';
import notification from '../../../services/notification';

function* getExchageBalance({ payload }) {
  try {
    const { data, status } = yield call(api.profile.getUserBalances, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_EXCHANGE_BALANCE_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_EXCHANGE_BALANCE_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

function* getMarginBalance({ payload }) {
  try {
    const { data, status } = yield call(api.profile.getUserMarginBalance, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_MARGIN_BALANCE_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_MARGIN_BALANCE_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

function* getHistory({ payload }) {
  try {
    const { data, status } = yield call(api.profile.getUserTransactions, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_TRANSACTIONS_HISTORY_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_TRANSACTIONS_HISTORY_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

function* getFiatHistory({ payload }) {
  try {
    const { data, status } = yield call(api.profile.getUserFiatPayment, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({
      type: types.GET_TRANSACTIONS_HISTORY_FIAT_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({ type: types.GET_TRANSACTIONS_HISTORY_FIAT_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

function* updateUserBalance({ payload, id }) {
  try {
    const { data, status } = yield call(api.profile.updateUserBalance, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.UPDATE_USER_BALANCE_SUCCESS });
    yield put({ type: types.GET_EXCHANGE_BALANCE_START, payload: id });
  } catch (error) {
    yield put({ type: types.UPDATE_USER_BALANCE_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

export function* wallets() {
  yield all([
    yield takeLatest(types.GET_EXCHANGE_BALANCE_START, getExchageBalance),
    yield takeLatest(types.GET_MARGIN_BALANCE_START, getMarginBalance),
    yield takeLatest(types.GET_TRANSACTIONS_HISTORY_START, getHistory),
    yield takeLatest(types.GET_TRANSACTIONS_HISTORY_FIAT_START, getFiatHistory),
    yield takeLatest(types.UPDATE_USER_BALANCE_START, updateUserBalance),
  ]);
}
